<section class="shiksha-client-revenue" [attr.aria-label]="content.ariaLabel">
    <app-shiksha-dashboard-subtitle-header
        [title]="content.title"
        [subtitle]="content.subtitle"
        [iconName]="uiConfig.titleIconName"
        [iconSize]="uiConfig.titleIconSize"
    />

    @if (hasRows()) {
        <div class="shiksha-client-revenue__list">
            @for (item of clientTypeRevenues(); track item.label) {
                <article class="shiksha-client-revenue__item">
                    <div class="shiksha-client-revenue__row">
                        <p class="shiksha-client-revenue__label">{{ item.label }}</p>

                        <div class="shiksha-client-revenue__right">
                            <div class="shiksha-client-revenue__amounts">
                                <p class="shiksha-client-revenue__value-primary">
                                    {{ item.valuePrimary }}
                                </p>
                            </div>
                            <span
                                class="shiksha-client-revenue__share-tag"
                                [attr.aria-label]="shareTagAriaLabel(item.sharePercent)"
                            >
                                <span class="shiksha-client-revenue__share-tag-value">{{
                                    sharePercentLabel(item.sharePercent)
                                }}</span>
                                <span class="shiksha-client-revenue__share-tag-unit">%</span>
                            </span>
                        </div>
                    </div>

                    <div
                        class="shiksha-client-revenue__track"
                        role="group"
                        [attr.aria-label]="trackAriaLabel(item.label, item.sharePercent)"
                    >
                        <span class="shiksha-client-revenue__track-rail" aria-hidden="true">
                            <span
                                class="shiksha-client-revenue__fill"
                                [class.shiksha-client-revenue__fill--slim]="
                                    isSlimFill(item.sharePercent)
                                "
                                [style.width.%]="item.sharePercent"
                            ></span>
                        </span>
                    </div>
                </article>
            }
        </div>
    } @else {
        <div class="shiksha-client-revenue__empty">
            <p class="shiksha-client-revenue__empty-title">No revenue data available</p>
            <p class="shiksha-client-revenue__empty-text">
                There are no client type contributions for the selected filters.
            </p>
        </div>
    }
</section>
